import { render, staticRenderFns } from "./TherapyForm.vue?vue&type=template&id=49b6f36e"
import script from "./TherapyForm.vue?vue&type=script&lang=js"
export * from "./TherapyForm.vue?vue&type=script&lang=js"
import style0 from "./TherapyForm.vue?vue&type=style&index=0&id=49b6f36e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports